import { h } from 'preact'
import { signal } from '@preact/signals'
import { Publicite } from '../publicite/publicite.jsx'

export const bandeAccueilTvState = signal('')

const Carrousel = ({ carrousel, format, elementId }) => {
   if (!carrousel) return null

   const slides = JSON.stringify(carrousel.slides)

   return <harmony-carrousel format={format} slides={slides} elementId={elementId} />
}

export const BandeAccueilTv = ({ publicite, format, elementId }) => {
   const carrousel = bandeAccueilTvState.value?.carrousel_n1Tv || null

   return (
      <div class="row no-gutters mb-2" data-testid="bande-top-tv">
         <div class="col-12 col-lg-8">
            <Carrousel carrousel={carrousel} format={format} elementId={elementId} />
         </div>
         <div class="col-4 d-none d-lg-block">
            <div class="d-flex align-items-center bg-gray2 h-100" style={{ maxHeight: '310px' }}>
               <Publicite adsId={publicite.rmAdsId} type="rm" />
            </div>
         </div>
      </div>
   )
}
